<!--首页 金额占比饼图-->
<template>
    <div ref="accountedEcharts" style="width:98%;height:95%" class="center" />
</template>

<script>
import { mapState } from "vuex";
import Public from "@/public";
const echarts = require("echarts");
export default {
    data() {
        return {
            orderSummaryDatas: [],
            siteName: [],
            powerData: [],
            chart: null,
        };
    },
    computed: {
        ...mapState(["theme", "siteOrderSummary"]),
    },
    mounted() {
        this.chart = echarts.init(this.$refs.accountedEcharts);
    },
    watch: {
        siteOrderSummary: {
            handler(val) {
                this.orderSummaryDatas = JSON.parse(JSON.stringify(val));
                this.siteName = [];
                this.powerData = [];
                this.dealData(this.orderSummaryDatas);
            },
            deep: true,
        },
    },
    methods: {
        dataEcharts() {
            this.chart.setOption({
                title: [
                    {
                        text: "电量",
                        left: "10%",
                        top: "5%",
                        // textAlign: "center",
                        textStyle: {
                            fontSize: 20,
                            color: this.theme.pageFontColor,
                        },
                    },
                ],
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                    confine: true,
                },
                legend: {
                    // orient : 'vertical',
                    // x: "center",
                    data: this.siteName,
                    type: "scroll",
                    orient: "vertical",
                    right: "5%",
                    top: "20%",
                    textStyle: {
                        fontWeight: "normal",
                        fontSize: 12,
                        color: this.theme.pageFontColor,
                    },
                    bottom: "10%",
                },
                toolbox: {
                    show: true,
                    right: "5%",
                    top: "5%",
                    feature: {
                        saveAsImage: { show: true },
                        // restore: { show: true },
                    },
                },
                calculable: true,
                series: [
                    {
                        name: "电量",
                        type: "pie",
                        radius: "55%",
                        // center: ["10%", "100%"],
                        top: "5%",
                        width: "55%",
                        left: "10%",
                        // bottom: "20%",
                        data: this.powerData,
                    },
                ],
            });
        },
        dealData(orderSummaryDatas) {
            if (!orderSummaryDatas) {
                return;
            }
            orderSummaryDatas.sort(Public.createComprisonFunction("money"));
            if (orderSummaryDatas.length > 10) {
                orderSummaryDatas.slice(0, 10);
            }
            for (let i = 0; i < orderSummaryDatas.length; i++) {
                this.siteName.push(orderSummaryDatas[i].name);
                this.powerData.push({
                    value: orderSummaryDatas[i].power.toFixed(2),
                    name: orderSummaryDatas[i].name,
                });
            }
            this.dataEcharts();
        },
    },
};
</script>
<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
